import { useEffect, useState } from "react";

export function useAccessImperativeHandle<T>(ref: React.RefObject<T>): T | undefined | null {
    const [evaluatedRef,  setEvaluatedRef] = useState<T | undefined | null>(undefined);
    useEffect(() => {
        setTimeout(() => {
            setEvaluatedRef(ref.current);
        }, 1); // Use setTimeout to ensure the ref is updated after the component has rendered
    });

    return evaluatedRef;
}